import { render, staticRenderFns } from "./NotePreview.vue?vue&type=template&id=07f281ba&scoped=true&"
import script from "./NotePreview.vue?vue&type=script&lang=js&"
export * from "./NotePreview.vue?vue&type=script&lang=js&"
import style0 from "./NotePreview.vue?vue&type=style&index=0&id=07f281ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f281ba",
  null
  
)

export default component.exports